import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const rolGuardClient: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);


  const userData = authService.getUser();

   if( userData.rol === 'cliente') {
    return true;
  } else {
    if(userData.rol === 'admin'){router.navigate(["admin/home/dashboard"]);}
    if(userData.rol === 'monitorista'){router.navigate(["monitorist/home"]);}
    return false
  }
};
